import { RSAA } from 'redux-api-middleware';

export const CAA204_IS_FETCHING = 'CAA204_IS_FETCHING';
export const CAA204_GET_SUCCESS = 'CAA204_GET_SUCCESS';
export const CAA204_GET_ERROR = 'CAA204_GET_ERROR';
export const CAA204_ADD_GO_BACK = 'CAA204_ADD_GO_BACK';
export const CAA204_ADD_ERROR = 'CAA204_ADD_ERROR';
export const CAA204_EDIT_ERROR = 'CAA204_EDIT_ERROR';

// Initial State
export const initialState = {
  isFetching: false,
  isEditMode: false,
  error: null,
  groupId: null,
  groupName: null,
  loggedInUserId: null,
  userName: null,
  submitDate: null,
  planNumbers: null,
  memberPremium: null,
  employerPremium: null,
  selfFunded: null,
  erisa: ''
};

// Actions
export const getCAA204Info = () => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CAA204',
      controlAction: 'self',
      types: [CAA204_IS_FETCHING, CAA204_GET_SUCCESS, CAA204_GET_ERROR]
    }
  };
};

export const editCAA204 = data => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CAA204',
      controlAction: 'edit',
      body: data,
      types: [CAA204_IS_FETCHING, CAA204_GET_SUCCESS, CAA204_EDIT_ERROR]
    }
  };
};

export const createCAA204 = data => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CAA204',
      controlAction: 'bci:submit',
      body: data,
      types: [CAA204_IS_FETCHING, CAA204_GET_SUCCESS, CAA204_ADD_ERROR]
    }
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case CAA204_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case CAA204_GET_SUCCESS:
      let editMode = action.payload.submitDate != null;
      return {
        ...state,
        ...action.payload,
        isFetching: false,
        error: null,
        isEditMode: editMode
      };
    case CAA204_EDIT_ERROR:
    case CAA204_ADD_ERROR:
    case CAA204_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        create:
          action.payload && action.payload.state && action.payload.state.skipReset
            ? { ...state.create }
            : { ...initialState.create }
      };

    default:
      return state;
  }
};
